

const PoweredByFormitize = () => {
    return <p className="fz-form-powered-by">Powered by <a href="https://www.formitize.com" className='fz-form-powered-by-link' target="_blank" rel="noopener noreferrer">Formitize</a></p>;
}

export default PoweredByFormitize;